<template>
  <body class="u-body u-xl-mode" data-lang="en">
    <header class="u-clearfix u-header u-valign-bottom-sm u-valign-bottom-xs u-header">
      <a href="#" class="u-image u-logo u-image-1">
        <img src="../../../assets/warranty-images/logo-anewday_1full_color.webp" class="u-logo-image u-logo-image-1">
      </a>
    </header>

    <section class="u-align-center u-clearfix u-image u-shading u-section-1">
      <div class="u-clearfix u-sheet u-valign-middle-xs u-sheet-1">
        <h1 class="u-custom-font u-text u-title u-text-1">Online Warranty<br>&nbsp;Registration</h1>
        <p class="u-custom-font u-large-text u-text u-text-variant u-text-2">กรุณากรอกหมายเลขสินค้า (S/N)<br>เพื่อเริ่มลงทะเบียนรับประกัน</p>
      </div>
    </section>

    <section class="u-clearfix u-section-3">
      <div class="u-clearfix u-sheet u-sheet-1">
        <div class="u-clearfix u-expanded-width u-gutter-0 u-layout-wrap u-layout-wrap-1">
          <div class="u-gutter-0 u-layout"><div class="u-layout-col">
            <div class="u-align-center u-container-style u-layout-cell u-radius-20 u-size-60 u-layout-cell-1">
              <div class="u-container-layout u-container-layout-1" style="padding:30px">
                <h3 class="u-text u-text-1">กรอกหมายเลขสินค้า / Enter Serial Number</h3>

                <div class="px-8 mt-5">
                  <div v-if="errorMsg" class="bg-red-100 rounded-lg py-3 px-6 text-base text-red-700 inline-flex items-center w-full mb-4" role="alert">
                    <svg class="w-4 h-4 mr-2 fill-current" viewBox="0 0 512 512"><path fill="currentColor" d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm121.6 313.1c4.7 4.7 4.7 12.3 0 17L338 377.6c-4.7 4.7-12.3 4.7-17 0L256 312l-65.1 65.6c-4.7 4.7-12.3 4.7-17 0L134.4 338c-4.7-4.7-4.7-12.3 0-17l65.6-65-65.6-65.1c-4.7-4.7-4.7-12.3 0-17l39.6-39.6c4.7-4.7 12.3-4.7 17 0l65 65.7 65.1-65.6c4.7-4.7 12.3-4.7 17 0l39.6 39.6c4.7 4.7 4.7 12.3 0 17L312 256l65.6 65.1z"></path></svg>
                    {{ errorMsg }}
                  </div>
                </div>

                <div class="u-form u-form-1" style="max-width:500px;margin:20px auto">
                  <div class="u-form-group u-label-top">
                    <label class="u-custom-font u-label" style="font-size:1.125rem;font-family:Kanit">หมายเลขสินค้า / Serial Number (S/N) : *</label>
                    <input v-model.trim="serialNumber" type="text" placeholder="เช่น AND250100001"
                      class="u-border-2 u-border-black u-border-no-left u-border-no-right u-border-no-top u-custom-font u-input u-input-rectangle u-white"
                      style="font-family:Kanit;font-size:1.2rem;text-align:center"
                      @keyup.enter="goToRegister">
                    <p style="font-family:Kanit;font-size:0.85rem;color:#999;margin-top:8px">หมายเลข S/N อยู่บนสติกเกอร์ที่ตัวสินค้าหรือกล่อง</p>
                  </div>

                  <div class="u-align-center u-form-group u-form-submit u-label-top mt-5">
                    <a @click="goToRegister" style="background-color:#f29802 !important" href="#"
                      class="u-active-palette-1-light-2 u-border-none u-btn u-btn-round u-btn-submit u-button-style u-custom-font u-hover-palette-1-light-1 u-palette-1-base u-radius-12 u-btn-1">
                      ลงทะเบียน / Register
                    </a>
                  </div>
                </div>

              </div>
            </div>
          </div></div>
        </div>
      </div>
    </section>
  </body>
</template>

<script>
export default {
  name: 'WarrantyEnterSN',
  created() { document.title = "A New Day - Enter S/N" },
  data() {
    return {
      serialNumber: '',
      errorMsg: ''
    }
  },
  methods: {
    goToRegister() {
      this.errorMsg = ''
      if (!this.serialNumber) {
        this.errorMsg = 'กรุณากรอกหมายเลขสินค้า'
        return
      }
      this.$router.push({ path: `/warranty-register/${this.serialNumber}` })
    }
  }
}
</script>

<style scoped>
.u-section-1 {
  background-image: linear-gradient(0deg, rgba(0,0,0,0.55), rgba(0,0,0,0.55)), url("../../../assets/warranty-images/banner-home1.webp");
  background-position: 50% 50%;
  min-height: 200px;
}
.u-section-1 .u-text-1 { font-family: Kanit; font-size: 2.5rem; color: #fff; }
.u-section-1 .u-text-2 { font-family: Kanit; font-size: 1rem; color: #fff; }
</style>
